'use client';

import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState
} from 'react';
import { DealerPriceAvailabilityResponse } from 'services/dealerPriceAvailability/types';
import {
  PriceAvailabilityResponseHeadless,
  SubTotalResults
} from 'services/priceAvailability/types';

type PriceAndFitmentContextProviderProps = {
  children: ReactNode;
};
type Context = {
  priceAndAvailability:
    | DealerPriceAvailabilityResponse
    | PriceAvailabilityResponseHeadless;
  setPriceAndAvailability: Dispatch<
    SetStateAction<
      DealerPriceAvailabilityResponse | PriceAvailabilityResponseHeadless
    >
  >;
  fitmentResponse: ProductFitmentResponse;
  setFitmentResponse: Dispatch<SetStateAction<ProductFitmentResponse>>;
  setUrlParams: Dispatch<SetStateAction<string | null>>;
  urlParams: string;
  subTotalResult: SubTotalResults;
  setSubTotalResult: Dispatch<SetStateAction<SubTotalResults | null>>;
};

export const PriceAndFitmentContext = createContext<Context>(null);

export const PriceAndFitmentContextProvider = ({
  children
}: PriceAndFitmentContextProviderProps) => {
  const [priceAndAvailability, setPriceAndAvailability] = useState(null);
  const [urlParams, setUrlParams] = useState(null);
  const [fitmentResponse, setFitmentResponse] = useState(null);
  const [subTotalResult, setSubTotalResult] = useState(null);

  const contextValues = useMemo(
    () => ({
      priceAndAvailability,
      setPriceAndAvailability,
      fitmentResponse,
      setFitmentResponse,
      urlParams,
      setUrlParams,
      subTotalResult,
      setSubTotalResult
    }),
    [priceAndAvailability, fitmentResponse, urlParams, subTotalResult]
  );

  return (
    <PriceAndFitmentContext.Provider value={contextValues}>
      {children}
    </PriceAndFitmentContext.Provider>
  );
};

export const usePriceAndFitmentContext = () =>
  useContext(PriceAndFitmentContext);
